import { AdminData, AdminModel } from '../../interfaces/admin-interface';
import { formatDateWithTimeWithSeconds } from '../../utils/helper';

export const getAdminListData = (admins: AdminModel[]): AdminData[] => {
    return admins.map(admin => ({
        id: admin.id,
        username: admin.username,
        email: admin.email || '-',
        last_logged_at: formatDateWithTimeWithSeconds(admin.last_logged_at),
        status: admin.status,
        cognito_id: admin.cognito_id || '-',
        first_name: admin.first_name,
        last_name: admin.last_name,
        phone_number: admin.phone_number,
        role_id: admin.role_id,
    }));
};
